var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchantnameFlt),
      callback: function($$v) {
        _vm.merchantnameFlt = $$v
      },
      expression: "merchantnameFlt"
    }
  })], 1)], 1), _vm._v(" "), (_vm.slaflag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sla.sla')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSLA),
      expression: "searchSLA"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchSLA"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSLA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Within SLA"
    }
  }, [_vm._v("Within SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near SLA"
    }
  }, [_vm._v("Near SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SLA Breached"
    }
  }, [_vm._v("SLA Breached")])])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderNumber')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ponoFlt",
      "placeholder": _vm.$t('orders.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.ponoFlt),
      callback: function($$v) {
        _vm.ponoFlt = $$v
      },
      expression: "ponoFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "shipidflt",
      "placeholder": _vm.$t('orders.shipmentIdPlaceHolder')
    },
    model: {
      value: (_vm.shipidflt),
      callback: function($$v) {
        _vm.shipidflt = $$v
      },
      expression: "shipidflt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v(_vm._s(channel.saleschannel))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.hideShowdateFlt]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderStatusPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.orderstatuslist), function(ordstatus) {
    return _c('option', {
      domProps: {
        "value": ordstatus.status
      }
    }, [_vm._v(_vm._s(ordstatus.status))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.fromShipDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toShipDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.statusFlag == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.FromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFltStatus),
      callback: function($$v) {
        _vm.fromDateFltStatus = $$v
      },
      expression: "fromDateFltStatus"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusFlag == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFltStatus),
      callback: function($$v) {
        _vm.toDateFltStatus = $$v
      },
      expression: "toDateFltStatus"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rtv')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtvType),
      expression: "rtvType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "rtvType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rtvType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectrtvtype')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Accept"
    }
  }, [_vm._v("RTV/Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Reject"
    }
  }, [_vm._v("RTV/Reject")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s2 o1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('orders.orderList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 s2 o2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2  s1 o3 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.resultCount))])]), _vm._v(" "), _c('div', {
    staticClass: " cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-2 s1 o4"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 csvbtn"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getOrderList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 xlsbtn"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('merchant.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalOrderQTY')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ordercode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipementStatus')))])]), _vm._v(" "), (_vm.slaflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('sla.sla')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderStatus')))])]), _vm._v(" "), (_vm.displayCancel) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listOrdersData), function(data, index) {
    return _vm._l((data.iteminfo), function(iteminfo, key) {
      return _c('tr', {
        staticClass: "text-center"
      }, [(key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [(data.btoborder == 1) ? _c('i', {
        staticClass: "fa fa-briefcase",
        staticStyle: {
          "margin-top": "5px",
          "float": "left"
        },
        attrs: {
          "title": "B2B Order"
        }
      }) : _vm._e(), _vm._v(" "), (data.status != 'Rejected') ? _c('a', {
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Order Details"
        },
        on: {
          "click": function($event) {
            _vm.showorderDetailsForm(data)
          }
        }
      }, [_vm._v(_vm._s(data.poid))]) : _vm._e(), _vm._v(" "), (data.status == 'Rejected') ? _c('a', {
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Rejected Order Details"
        },
        on: {
          "click": function($event) {
            _vm.showRejectInfo(data.poid)
          }
        }
      }, [_vm._v(_vm._s(data.poid))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v(_vm._s(data.merchant))]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v(_vm._s(data.saleschannel))]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v(_vm._s(_vm.dateFormatFRT(data.orderdate)))]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v(_vm._s(data.totalitem))]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.prodids.length
        }
      }, [_vm._v("\n                    " + _vm._s(data.totalquantity) + "\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((iteminfo), function(value, name, index) {
        return ((_vm.slaflag && name != 9 && name != 10) || (!_vm.slaflag && name != 8 && name != 9 && name != 10)) ? _c('td', [(value == null && (name != 8 && name != 9 && name != 10)) ? _c('span', [_vm._v("- ")]) : _vm._e(), _vm._v(" "), (value != '' && (name != 8 && name != 9 && name != 10)) ? _c('span', [_vm._v("\n                     " + _vm._s(value) + " \n                    ")]) : (value != null && _vm.slaflag && (name == 8)) ? _c('span', [_vm._v("\n                      " + _vm._s(iteminfo[9]) + "\n                      "), (iteminfo[10] == 'SLA Breached') ? _c('span', {
          staticClass: "badge badge-danger",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('sla.slabreached')))]) : (iteminfo[10] == 'Near SLA') ? _c('span', {
          staticClass: "badge badge-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_vm._v(" " + _vm._s(Math.trunc(iteminfo[8] / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(iteminfo[8] % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : (iteminfo[10] == 'Within SLA') ? _c('span', {
          staticClass: "badge badge-info",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_vm._v(" " + _vm._s(Math.trunc(iteminfo[8] / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(iteminfo[8] % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : _vm._e()]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), (key == 0 && data.shipmentstatusmaster.indexOf('rto') == -1) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v(_vm._s(data.status) + "\n\n                    "), (data.shipmentstatusct > 1) ? _c('span', {
        staticClass: "fa fa-cart-plus",
        staticStyle: {
          "font-size": "17px",
          "color": "#ff9900"
        },
        attrs: {
          "title": "Shipment with Handover Pending status"
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (data.shipmentstatusmaster.indexOf('rto') > -1 && key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [_vm._v("rto")]) : _vm._e(), _vm._v(" "), ((data.shipmentcount == 'null' || data.shipmentcount == 0) && _vm.displayCancel && key == 0) ? _c('td', {
        attrs: {
          "rowspan": data.itemids.length
        }
      }, [(_vm.modifyOrderFlag == true) ? _c('span', [(data.status != 'cancelled' && data.status != 'dispatched' && data.status != 'sr' && data.status != 'packed' && data.status != 'Rejected' && data.status != 'rto') ? _c('i', {
        staticClass: "fa fa-edit fa-lg mt-2 ml-3",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Modify Order"
        },
        on: {
          "click": function($event) {
            _vm.geModifyOrder(data)
          }
        }
      }) : _vm._e(), _vm._v(" "), (iteminfo[6] == 'packed') ? _c('i', {
        staticClass: "fa fa-dropbox fa-lg mt-2 ml-3",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Unpack"
        },
        on: {
          "click": function($event) {
            _vm.getUnPackBox(data, iteminfo[1])
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cancelOrderFlag == true) ? _c('span', [(iteminfo[6] != 'dispatched' && iteminfo[6] != 'cancelled' && iteminfo[6] != 'sr' && data.status != 'rto' && data.status != 'Rejected') ? _c('i', {
        staticClass: "fa fa-times fa-lg mt-2 ml-3",
        staticStyle: {
          "cursor": "pointer",
          "color": "#ff0000"
        },
        attrs: {
          "title": "Cancel Order"
        },
        on: {
          "click": function($event) {
            _vm.orderCancelShow = true;
            _vm.cancelreasonid = '';
            _vm.OthersReason = '';
            _vm.cancelOrderId = data.poid;
            _vm.shipmentid = data.shipids[key]
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [(data.status == 'Rejected' && data.source == 'Unicommerce') ? _c('i', {
        staticClass: "fa fa-refresh fa-lg",
        staticStyle: {
          "color": "lightseagreen",
          "cursor": "pointer"
        },
        attrs: {
          "title": "Pull Order"
        },
        on: {
          "click": function($event) {
            _vm.PullRejectOrders(data)
          }
        }
      }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (Number(data.shipmentcount) > 0 && _vm.displayCancel) ? _c('td', [(_vm.modifyOrderFlag == true && _vm.displayCancel && key == 0) ? _c('span', [(data.status != 'cancelled' && data.status != 'sr' && data.status != 'dispatched' && data.status != 'Rejected' && data.status != 'rto' && data.status != 'packed') ? _c('i', {
        staticClass: "fa fa-edit fa-lg mt-2 ml-3",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Modify Order"
        },
        on: {
          "click": function($event) {
            _vm.geModifyOrder(data)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (iteminfo[6] == 'packed') ? _c('i', {
        staticClass: "fa fa-dropbox fa-lg mt-2 ml-3",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Unpack"
        },
        on: {
          "click": function($event) {
            _vm.getUnPackBox(data, iteminfo[1])
          }
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((data.shipmentcount), function(iteminfo3, key2) {
        return (_vm.cancelOrderFlag == true && iteminfo[5] != 'cancelled') ? _c('span', [(iteminfo[6] != 'dispatched' && iteminfo[6] != 'cancelled' && iteminfo[6] != 'sr' && data.status != 'rto' && _vm.cancelOrderFlag == true && data.status != 'Rejected') ? _c('i', {
          staticClass: "fa fa-times fa-lg mt-2 ml-3",
          staticStyle: {
            "cursor": "pointer",
            "color": "#ff0000"
          },
          attrs: {
            "title": "Cancel Order"
          },
          on: {
            "click": function($event) {
              _vm.orderCancelShow = true;
              _vm.cancelreasonid = '';
              _vm.OthersReason = '';
              _vm.cancelOrderId = data.poid;
              _vm.shipmentid = data.shipids[key]
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('span', [(data.status == 'Rejected' && data.source == 'Unicommerce') ? _c('i', {
        staticClass: "fa fa-refresh fa-lg",
        staticStyle: {
          "color": "lightseagreen",
          "cursor": "pointer"
        },
        attrs: {
          "title": "Pull Order"
        },
        on: {
          "click": function($event) {
            _vm.PullRejectOrders(data)
          }
        }
      }) : _vm._e()])], 2) : _vm._e()], 2)
    })
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "shipmentdetails"
    },
    model: {
      value: (_vm.shipmentdetails),
      callback: function($$v) {
        _vm.shipmentdetails = $$v
      },
      expression: "shipmentdetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.shipmentDetailsForOrder')) + " : " + _vm._s(_vm.orderidshipment) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.shipmentDetailsClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('supportRequest.sku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('cameraApp.rejectReason')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentdetailslist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data._id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.skuquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.reject_reason))])])
  }), _vm._v(" "), (_vm.shipmentdetailslist.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.modifyOrdere),
      callback: function($$v) {
        _vm.modifyOrdere = $$v
      },
      expression: "modifyOrdere"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modifyOrdere),
      expression: "modifyOrdere"
    }],
    staticClass: "col-12"
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "margin": "0px !important"
    }
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('orders.cancelOrderproductList')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.modifyOrdere = false
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', {
    staticClass: "header float-left",
    staticStyle: {
      "margin-left": "48px",
      "font-family": "Times New Roman, Times, serif",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', {
    staticClass: "header float-right",
    staticStyle: {
      "font-size": "15px",
      "font-family": "Times New Roman, Times, serif"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderId')) + ":- " + _vm._s(_vm.modifyOrderID))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.srNo')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.eanCode')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')) + " ")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')) + " ")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemId')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.ProductName')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.modifyQuantity')))])])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.orderProdList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "5%"
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.eancode) + " ")])]), _vm._v(" "), (data.shipmentid != null) ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.shipmentid) + " ")])]) : _vm._e(), _vm._v(" "), (data.shipmentid == null) ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.productid) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.itemid) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "20%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.productname) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.orderqty) + " ")])]), _vm._v(" "), (data.orderqty > 0) ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.modifyqty),
        expression: "data.modifyqty"
      }],
      staticStyle: {
        "height": "30px",
        "width": "100%",
        "text-align": "center"
      },
      attrs: {
        "type": "number",
        "min": 0,
        "max": data.orderqty,
        "placeholder": _vm.$t('orders.quantityplaceholder')
      },
      domProps: {
        "value": (data.modifyqty)
      },
      on: {
        "keyup": function($event) {
          _vm.checkmodifyqty(data, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.modifyqty = $event.target.value
        }
      }
    }), _vm._v(" "), (data.isqtycheck == false) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.qtyErr))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (data.orderqty == 0) ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.modifyqty),
        expression: "data.modifyqty"
      }],
      staticStyle: {
        "height": "30px",
        "width": "100%",
        "text-align": "center"
      },
      attrs: {
        "type": "number",
        "min": 0,
        "max": data.orderqty,
        "placeholder": _vm.$t('orders.quantityplaceholder'),
        "disabled": ""
      },
      domProps: {
        "value": (data.modifyqty)
      },
      on: {
        "keyup": function($event) {
          _vm.checkmodifyqty(data, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.modifyqty = $event.target.value
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.isqtycheck) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('orders.modifyQuantityPlaceHolder')))])])]) : _vm._e()], 2), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.comfirmModal),
      callback: function($$v) {
        _vm.comfirmModal = $$v
      },
      expression: "comfirmModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.comfirmModal = false;
        _vm.modifyOrdere = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_vm._v("\n                      " + _vm._s(_vm.modalHeader) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-primary glass",
    staticStyle: {
      "width": "105px !important",
      "margin-left": "254px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmation()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.modalTitle) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary glass",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.comfirmModal = false;
        _vm.modifyOrdere = false;
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.back')) + "\n                      ")])])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row text-align: center"
  }, [(_vm.errmessage != "") ? _c('label', {
    staticStyle: {
      "float": "middle"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('orders.errorMessage')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row float-right"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.modifyOrderValidate
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.confirm')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.modifyOrdere = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')) + " ")])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.orderCancelShow),
      callback: function($$v) {
        _vm.orderCancelShow = $$v
      },
      expression: "orderCancelShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('orders.cancelOrder')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.orderCancelShow = false;
        _vm.cancelreasonid = '';
        _vm.OthersReason = ''
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('orders.cancelOrderPopup')) + "?\n\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.cancelReason')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelreasonid),
      expression: "cancelreasonid"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "reason",
      "id": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cancelreasonid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectCancelReason')))]), _vm._v(" "), _vm._l((_vm.listCancelReasonData), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.reasonname
      }
    }, [_vm._v(_vm._s(Reason_obj.reasonname))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.others')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OthersReason),
      expression: "OthersReason"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "name": "Others",
      "id": "Others",
      "placeholder": _vm.$t('orders.othersPlaceHolder')
    },
    domProps: {
      "value": (_vm.OthersReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.OthersReason = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelOrder()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n              " + _vm._s(_vm.$t('orders.cancelOrder')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.orderCancelShow = false;
        _vm.cancelOrderId = '';
        _vm.cancelreasonid = '';
        _vm.OthersReason = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.back')) + "\n            ")])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "rejectdetails"
    },
    model: {
      value: (_vm.rejectdetails),
      callback: function($$v) {
        _vm.rejectdetails = $$v
      },
      expression: "rejectdetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('shipment.rejectedOrders')) + " : " + _vm._s(_vm.orderid) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.rejectdetailsClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('shipment.rejectedReasons')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rejectdetailslist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.orderitemid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.linestatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejectedreasons))])])
  }), _vm._v(" "), (_vm.shipmentdetailslist.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.table.noRecordFoundMsg')) + " ")])]) : _vm._e()], 2)])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showlist == false) ? _c('div', [_c('div', [_c('orderdetailsaccordian', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c68eef3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c68eef3","hasScoped":true}!./src/views/components/reports/orderlist/orderlist.component.html
// module id = 1492
// module chunks = 0